import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './dateNavigator.css';

type DateNavigatorPropsType = {
  onBack: Function;
  onToday: Function;
  onForward: Function;
};

const DateNavigator = (props: DateNavigatorPropsType) => {
  return (
    <div style={{ display: 'flex' }}>
      <button
        className="clickable date-navigator__item"
        onClick={() => props.onBack()}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </button>
      <button
        className="clickable date-navigator__item"
        onClick={() => props.onToday()}
      >
        Today
      </button>
      <button
        className="clickable date-navigator__item"
        onClick={() => props.onForward()}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
    </div>
  );
};

export default DateNavigator;
